// 接口和页面初始化配置中心
// 在前置配置之前，需要搞清楚后端微服务前缀路由是什么，然后再配置到该文件下面
import qs from 'qs'

const gateway = '/nbs'
let service = {
  domainName: '', // 主域名
  gateway, // 流量网关前缀,后面的才是微服务后端代码前缀
  mobServer: '/openapi',
  communityServer: '/community-server',
  baseServer: '/base-server',
  miniH5Prefix: '/mini-h5', // 原生转译后的h5目录前缀,类似customer-h5
  miniWap: '', // 原生转译后的部署域名，除了dev环境，其他环境应该与nbsWap相同
}

export const ENV = {
  DEV: 'development',
  PRE: 'pre',
  PRD: 'production',
  PREPRD: 'production',
  SST: 'sst',
}
const search = window.location.search.replace('?', '')
let { env = '' } = qs.parse(search) || {} // env原生传过来的环境参数，sit
env = env || sessionStorage.getItem('env') || ''
sessionStorage.setItem('env', env)
let localEnv = env.toUpperCase && env.toUpperCase() // 例：sit => SIT
if (localEnv) {
  localEnv = ENV[localEnv] // SIT => staging
}
const buildEnv = import.meta.env.VITE_APP_ENV // 当前项目的打包环境
const enviroment = buildEnv // 非生产环境支持切换接口环境
export const YZFYSF_ACT_ID = enviroment !== ENV.PRD ? 60 : 62
// 只有中旅旅行微信小程序是跳新的的b2c，其他都是跳转旧的
// 浏览器、中旅通H5也跳新的
const getLocation = () => {
  if (enviroment === ENV.PRD || enviroment === ENV.PRE) {
    return 'https://zl.ourtour.com/index.htm#/'
  } else if (enviroment === ENV.SIT || enviroment === ENV.SST) {
    return 'https://testb2c1.ourtour.com/m/mtest/index.htm#/'
  } else if (enviroment === ENV.DEV) {
    return 'https://zl.ourtour.com/index.htm#/'
  }
}
const TEST_SERVER = 'https://ts-api.ourtour.com/'
const PRE_SERVER = 'https://pre-api.ourtour.com/'
const PRO_SERVER = 'https://pro-api.ourtour.com/'
const DEV_SERVER = 'https://dev-openapi.ctg-inc.cn/'

switch (enviroment) {
  // 开发, 本地开发走vue代理
  case ENV.DEV: {
    service = {
      ...service,
      domainName: TEST_SERVER,
      imgDomain: 'https://sst-nbs.cits.com.cn',
      nbsWap: 'https://sst-wap.ourtour.com',
      miniWap: 'https://zltest.ourtour.com:10086', // 注意配置本地host
      miniH5Prefix: '',
      couponList: 'https://testb2c1.ourtour.com/m/nbstest/index.htm#/',
      getLocation,
      marketListId: '2886', // 云闪付首页id后缀
      VIP_URL: 'https://vip-test.ctgbs.com/#',
      VIP_CUSTOMER_HASH_CODE: '72bcba983cd3b0bf1d4251311d8b3772',
      ZHICHI_URL:
        'https://callcenter-test.ctgbs.com/chat/h5/v2/index.html?sysnum=f4ba20fd378e4cd89ea0a2884f2d8e90',
      CLIENT_URL: 'https://ts-m.ourtour.com/#',
    }
    break
  }
  //sst测试环境
  case ENV.SST: {
    service = {
      ...service,
      domainName: 'https://ts-api.ourtour.com',
      imgDomain: 'https://sst-nbs.cits.com.cn',
      nbsWap: 'https://sst-wap.ourtour.com',
      miniWap: 'https://sst-wap.ourtour.com',
      ourtor: 'https://testb2c1.ourtour.com',
      couponList: 'https://testb2c1.ourtour.com/m/nbstest/index.htm#/',
      getLocation,
      marketListId: '2886',
      VIP_URL: 'https://vip-test.ctgbs.com/#',
      VIP_CUSTOMER_HASH_CODE: '72bcba983cd3b0bf1d4251311d8b3772',
      ZHICHI_URL:
        'https://callcenter-test.ctgbs.com/chat/h5/v2/index.html?sysnum=f4ba20fd378e4cd89ea0a2884f2d8e90',
      CLIENT_URL: 'https://ts-m.ourtour.com/#',
    }
    break
  }
  // 预发布
  case ENV.PRE: {
    service = {
      ...service,
      domainName: 'https://pre-api.ourtour.com',
      imgDomain: 'https://nbs.cits.com.cn',
      nbsWap: 'https://wap.ourtour.com',
      miniWap: 'https://wap.ourtour.com',
      ourtor: 'https://zl.ourtour.com',
      couponList: 'https://zl.ourtour.com/index.htm#/',
      getLocation,
      marketListId: '4333',
      VIP_URL: 'https://vip.ctgbs.com/#',
      VIP_CUSTOMER_HASH_CODE: '2ea279ca696946aceb4337fb1ba9b23a',
      ZHICHI_URL:
        'https://callcenter.ctgbs.com/chat/h5/v2/index.html?sysnum=266b27c31c3b482ba170ac81254ed8b0',
      CLIENT_URL: 'https://pre-m.ourtour.com/#',
    }
    break
  }
  // 生产
  case ENV.PRD: {
    service = {
      ...service,
      domainName: 'https://pro-api.ourtour.com',
      imgDomain: 'https://nbs.cits.com.cn',
      nbsWap: 'https://wap.ourtour.com',
      miniWap: 'https://wap.ourtour.com',
      ourtor: 'https://zl.ourtour.com',
      couponList: 'https://zl.ourtour.com/index.htm#/',
      getLocation,
      marketListId: '4333',
      VIP_URL: 'https://vip.ctgbs.com/#',
      VIP_CUSTOMER_HASH_CODE: '2ea279ca696946aceb4337fb1ba9b23a',
      ZHICHI_URL:
        'https://callcenter.ctgbs.com/chat/h5/v2/index.html?sysnum=266b27c31c3b482ba170ac81254ed8b0',
      CLIENT_URL: 'https://pro-m.ourtour.com/#',
    }
    break
  }
}

export default service
